import AWS from 'aws-sdk'
import deliveryMethods from '../mixins/delivery-methods'

export default {
  methods: {
    /**
     * PresignedUrlを生成して返却を行う
     * @param {*} bucketName バケット名
     * @param {*} key キー
     * @returns PresignedUrl
     */
    createPresignedUrl: function (bucketName, key) {
      AWS.config.update({
        accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY,
        secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
        region: 'ap-northeast-1'
      })

      return new Promise(resolve => {
        var s3 = new AWS.S3({
          signatureVersion: 'v4'
        })
        var params = {Bucket: bucketName, Key: key, Expires: 1800}
        s3.getSignedUrl('getObject', params, function (_err, url) {
          resolve(url)
        })
      })
    },
    /**
     * PresignedUrlを生成して返却を行う
     * @param {*} bucketName バケット名
     * @param {*} key キー
     * @returns PresignedUrl
     */
    createPdfPresignedUrl: function (bucketName, key) {
      AWS.config.update({
        accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY,
        secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
        'region': 'ap-northeast-1' })

      return new Promise(resolve => {
        var s3 = new AWS.S3({
          signatureVersion: 'v4'
        })
        var params = {Bucket: bucketName, Key: key, Expires: 1800, ResponseContentType: 'application/pdf'}
        s3.getSignedUrl('getObject', params, function (_err, url) {
          resolve(url)
        })
      })
    },
    /**
     * ファイル名を変更してダウンロードを行うPresignedUrlを生成して返却を行う
     * @param {*} bucketName バケット名
     * @param {*} key キー
     * @param {*} fileName ファイル名
     * @returns PresignedUrl
     */
    createNamePresignedUrl: function (bucketName, key, fileName) {
      AWS.config.update({
        accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY,
        secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
        region: 'ap-northeast-1'
      })

      var originalFileName = ''
      var userAgent = window.navigator.userAgent.toLowerCase()
      if (userAgent.indexOf('edge') !== -1 || userAgent.indexOf('chrome') !== -1) {
        // edge chrome
        originalFileName = 'attachment; filename ="' + encodeURI(fileName, 'UTF8') + '"'
      } else if (userAgent.indexOf('safari') !== -1) {
        // safari
        originalFileName = "attachment; filename*=UTF-8''" + encodeURIComponent(fileName)
      }

      return new Promise(resolve => {
        var s3 = new AWS.S3({
          signatureVersion: 'v4'
        })
        var params = {Bucket: bucketName, Key: key, Expires: 1800, ResponseContentDisposition: originalFileName}
        s3.getSignedUrl('getObject', params, function (_err, url) {
          resolve(url)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/S3Downloader.js